import { getAirbrake } from "@simplybusiness/services";
import { useMutation } from "@tanstack/react-query";
import {
  AIRBRAKE_PROJECT_ID,
  AIRBRAKE_PROJECT_KEY,
} from "../../constants/constants";
import type { QuoteComparisonPageProps } from "../../pages";
import { apiRequest } from "../../utils/apiRequest";
import { useTokens } from "../tokens";
import { useQuoteComparisonPageState } from "../useQuoteComparisonPageState";

const airbrake = getAirbrake({
  projectId: AIRBRAKE_PROJECT_ID,
  projectKey: AIRBRAKE_PROJECT_KEY,
});

type ToggleCoversResponse = {
  data: QuoteComparisonPageProps;
};

// This request will send an array of one cover
export const useToggleCovers = () => {
  const [tokens, setTokens] = useTokens();
  const [, setComponents] = useQuoteComparisonPageState();

  const mutation = useMutation({
    mutationFn: (cover: { name: string; value: string }) =>
      apiRequest("?step_action=toggle_qcp_component_cover", {
        ...tokens,
        coverToggleData: [
          {
            coverName: cover.name,
            coverValue: cover.value,
          },
        ],
      }) as Promise<ToggleCoversResponse>,
    mutationKey: ["toggleCovers"],
  });

  const { isPending, isError, error, isSuccess, mutate } = mutation;

  const toggleCovers = (cover: { name: string; value: string }) => {
    mutate(cover, {
      onSuccess: ({ data }: ToggleCoversResponse) => {
        // Dispatch data to page store
        setComponents(data.layout.components);
        // Update tokens atom
        setTokens(data.configuration);
      },
      onError: (error: Error) => {
        console.error(`Error toggling covers: ${error.message}`);
        void airbrake.notify(error);
      },
    });
  };

  return {
    toggleCovers,
    isSuccess,
    isPending,
    isError,
    error,
  };
};
